// Ramblin Trades Coffee Co. — core theme interactions
document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var mobileToggle = document.querySelector('.rt-mobile-toggle');
  var nav = document.querySelector('.rt-nav');
  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // FAQ / accordion sections
  document.querySelectorAll('.rt-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.rt-accordion__item');
      var wasOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.rt-accordion__item').forEach(function (el) {
        el.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  // Purchase option selector (one-time vs subscribe & save)
  document.querySelectorAll('.rt-purchase-option').forEach(function (option) {
    option.addEventListener('click', function () {
      var group = option.closest('[data-purchase-options]');
      if (!group) return;
      group.querySelectorAll('.rt-purchase-option').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      option.classList.add('is-selected');
      var radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });

  // Sticky add-to-cart bar: reveal once main product form scrolls out of view
  var stickyAtc = document.querySelector('.rt-sticky-atc');
  var mainAtc = document.querySelector('[data-main-add-to-cart]');
  if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }

  // Reveal-on-scroll for lifestyle/story sections
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }
});
